(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nulven-guia"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nulven-guia')) {
    customElements.define('nulven-guia', class extends HTMLElement {
      connectedCallback() {
        const tabs = this.querySelectorAll('[data-perfil]');
        tabs.forEach((t) => t.addEventListener('click', () => {
          tabs.forEach((x) => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
          this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== t.dataset.perfil; });
        }));

        const puntos = this.querySelectorAll('[data-punto]');
        puntos.forEach((p) => p.addEventListener('click', () => {
          puntos.forEach((x) => x.setAttribute('aria-pressed', x === p ? 'true' : 'false'));
          this.querySelectorAll('[data-ficha]').forEach((f) => { f.hidden = f.dataset.ficha !== p.dataset.punto; });
        }));

        this.querySelectorAll('.nv-guia__pasos').forEach((bloque) => this.#pasos(bloque));
        this.#video();
      }

      #pasos(bloque) {
        const pasos = bloque.querySelectorAll('[data-paso]');
        const barra = bloque.querySelector('.nv-guia__barra span');
        const etiqueta = bloque.querySelector('[data-etiqueta]');
        const [ant, sig] = bloque.querySelectorAll('[data-mover]');
        let n = 0;
        const ir = (k) => {
          n = Math.max(0, Math.min(pasos.length - 1, k));
          pasos.forEach((p, i) => {
            p.classList.toggle('is-hecho', i < n);
            if (i === n) p.setAttribute('aria-current', 'step');
            else p.removeAttribute('aria-current');
          });
          barra.style.width = ((n + 1) / pasos.length) * 100 + '%';
          etiqueta.textContent = `Paso ${n + 1} de ${pasos.length}`;
          ant.disabled = n === 0;
          sig.disabled = n === pasos.length - 1;
        };
        pasos.forEach((p) => p.addEventListener('click', () => ir(Number(p.dataset.paso))));
        ant.addEventListener('click', () => ir(n - 1));
        sig.addEventListener('click', () => ir(n + 1));
      }

      #video() {
        const video = this.querySelector('.nv-guia__marco video');
        if (!video) return;
        const poster = () => { if (video.dataset.poster) video.poster = video.dataset.poster; };
        if ('IntersectionObserver' in window) {
          const vigia = new IntersectionObserver((e) => {
            if (e.some((x) => x.isIntersecting)) { poster(); vigia.disconnect(); }
          }, { rootMargin: '600px 0px' });
          vigia.observe(video);
        } else poster();
        const play = this.querySelector('.nv-guia__play');
        const sonido = this.querySelector('.nv-guia__sonido');
        const alternar = () => (video.paused ? video.play() : video.pause());
        play.addEventListener('click', alternar);
        video.addEventListener('click', alternar);
        video.addEventListener('play', () => { play.hidden = true; });
        video.addEventListener('pause', () => { play.hidden = false; });
        sonido.addEventListener('click', () => {
          video.muted = !video.muted;
          sonido.setAttribute('aria-pressed', String(!video.muted));
          sonido.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Quitar sonido');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
